<template>
    <!-- <ValidationErrors :show="showErrors"/>
    <Head :title="quote.name + ' - ' + fixture.title"/> -->
    <div class="w-full mb-6">
      <FixtureHeader :fixture="fixture">
          <template v-slot:info>
              <p v-if="quote.buy_currency_id !== quote.sell_currency_id"><strong>Buy/Sell Currency:</strong> {{ quote.buy_currency.code }}/{{quote.sell_currency.code}} @ {{quote.exchange_rate }}</p>
          </template>
        <template v-slot:actions>
          <Link :href="route('frontend.fixture.quote.index', fixture.id)"
                class="inline-flex items-center h-10 px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs uppercase text-black bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
            <ArrowCircleLeftIcon class="-ml-0.5 mr-2 h-4 w-4"></ArrowCircleLeftIcon>
            Back to Quotes
          </Link>
        </template>
      </FixtureHeader>
      <div class="space-y-6 lg:col-span-9">
        <section aria-labelledby="payment-details-heading">
            <div class="shadow sm:rounded-md sm:overflow-hidden">
              <div class="bg-white px-4 p-6 space-y-6">
                <div class="pb-5 border-b border-gray-200 flex justify-between items-center">
                    <div>
                        <div class="flex items-end">
                            <h3
                                class="flex text-lg leading-6 font-bold text-gray-900 mr-3">
                                {{ quote.name }}
                            </h3>
                            <span class="text-sm font-medium">{{ quote.client.name }}</span>

                            <div class="ml-3 flex-col">
                                <span v-if="quote.status === 'Not Sent'"
                                    class="w-auto inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                                    quote.status
                                }} </span>
                                <span v-if="quote.status === 'Sent to Client'"
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-yellow-800"> {{
                                    quote.status
                                }} </span>
                                <span v-if="quote.status === 'Confirmed'"
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-green-800"> {{
                                    quote.status
                                }} </span>
                            </div>
                        </div>
                    </div>
                </div>
                <QuoteTabs />
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <InvoiceList :invoices="management_fee_invoices" :display_related_quotes="false" :invoice_type="'Management Fee'" />
                        </div>
                    </div>
                </div>
              </div>
            </div>
        </section>
      </div>
    </div>
  </template>


  <script>
  import Authenticated from "@/Layouts/Authenticated";
  import {Link, Head, usePage, useForm} from "@inertiajs/vue3";
  import AddServiceLines from "@/Components/SlideOuts/AddServiceLines";
  import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    CheckCircleIcon,
    ArrowCircleLeftIcon,
    FolderAddIcon,
    FolderIcon,
    DocumentAddIcon,
    DocumentDownloadIcon
  } from "@heroicons/vue/outline"
  import ValidationErrors from "@/Components/ValidationErrors";
  import FixtureHeader from "@/Components/FixtureHeader";
  import QuoteTabs from "@/Components/QuoteTabs";
  import CreateInvoice from "@/Components/SlideOuts/CreateInvoice";
  import Button from "@/Components/Button";
  import InvoiceList from "@/Components/InvoiceList.vue";
  import LinkInvoiceToSupplierInvoice from "@/Components/SlideOuts/LinkInvoiceToSupplierInvoice";


  export default {
    layout: Authenticated,
    components: {
        LinkInvoiceToSupplierInvoice,
      Button,
      QuoteTabs,
      FixtureHeader,
      ValidationErrors,
      Link,
      Head,
      PlusSmIcon,
      UsersIcon,
      InformationCircleIcon,
      ChevronDownIcon,
      CogIcon,
      PencilIcon,
      ClipboardCopyIcon,
      CheckCircleIcon,
      ArrowCircleLeftIcon,
      FolderAddIcon,
      FolderIcon,
      DocumentAddIcon,
      DocumentDownloadIcon,
      CreateInvoice,
      InvoiceList,
      AddServiceLines
    },
    props: {
      fixture: Object,
      quote: Object,
      invoices: Object,
      service_lines: Object,
      management_fee_invoices: Array,
    },
  }
  </script>
